import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const LoyaltyCreditHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.loyaltyCredit;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'LoyaltyCreditHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return (
    <HistoryComponent historyfilter={filterTypes.loyaltyCredit} {...props} />
  );
};

export default LoyaltyCreditHistoryList;
